import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select, { OptionType } from 'src/components/Select';
import TextField from 'src/components/TextField';
import { CarrierType } from 'src/types/carrier';
import { FormErrorsType, OnChangeType } from 'src/types/global';
import { ConstantsCodeType } from 'src/types/constantsCodes';

export interface DetailPropsType {
  onChange: OnChangeType<any>;
  editData: CarrierType;
  editErrors: FormErrorsType;
  newCarrier: boolean;
  disableEdit: boolean;
  shipperCodes: ConstantsCodeType[];
}

const Detail: FC<DetailPropsType> = (props) => {
  const shipperOptions: OptionType[] = props.shipperCodes || [];

  return (
    <>
      <Grid>
        <GridItem cols={3}>
          <Select
            value={props.editData.SHIPPER}
            onChange={(value, error) => props.onChange('SHIPPER', value, error)}
            name="SHIPPER"
            label={translate('carrierDetail.shipper')}
            options={shipperOptions}
            fullWidth
            required
            disabled={props.disableEdit}
          />
        </GridItem>
        <GridItem cols={3}>
          <TextField
            type={'time'}
            value={props.editData.COT}
            error={props.editErrors.COT}
            onChange={(value, error) => props.onChange('COT', value || null, error)}
            name="COT"
            label={translate('carrierDetail.cot')}
            fullWidth
            required
            disabled={props.disableEdit}
          />
        </GridItem>
      </Grid>
    </>
  );
};

export default Detail;

